module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-illustrations/maintain.svg?b1f2d04ce2de2efaff3a20930f57d3f8";